import {AuthRepository} from '@domain/model/Auth/AuthRepository';
import {UserLoginInfo} from '@domain/model/Auth/UserLoginInfo';

const GetLoginInfo = async (authRepository: AuthRepository): Promise<UserLoginInfo> => {
  return authRepository.getLoginInfo();
};

export {GetLoginInfo};
